/* SearchResultPageWithAtlassianApps.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "._1bsb1osq{width:100%}";
const _10 = "._zulputpp{gap:var(--ds-space-150,9pt)}";
const _9 = "._p12f1osq{max-width:100%}";
const _8 = "._1bsb1k7l{width:757px}";
const _7 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _6 = "._1yt4fkly{padding:0 var(--ds-space-400,2pc)}";
const _5 = "._1yt48v25{padding:0 0 var(--ds-space-800,4pc) 0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable complexity */
/* eslint-disable max-lines-per-function */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { Show } from '@atlaskit/primitives/responsive';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BackToTopButton, Filters, FluidContainer, PartialOutageError } from '@atlassian/mpac-primitives';
import Telemetry from '@atlassian/mpac-telemetry';
import { CompatibleProductName } from '@atlassian/mpac-types';
import { useQueryParams } from '@atlassian/mpac-ui';
import { isOptionSelected, useApplicationConfig, useSource } from '@atlassian/mpac-utils';
import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { ANALYTICS } from '../constants';
import { SearchEmbedded } from '../SearchEmbedded';
import { SearchHeading } from './components';
import { SearchResults } from './components/SearchResults';
import { useSearchFilters } from './hooks/useSearchFilters';
import { useSearchPageAnalytics } from './hooks/useSearchPageAnalytics';
import { useSearchPageTelemetry } from './hooks/useSearchPageTelemetry';
import { useSearchResults } from './hooks/useSearchResults';
import { getSearchQuery } from './SearchResultPageLegacy';
import { getOverridesByHostProduct } from './utils/filters/GetOverridesByHostProduct';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._1tke1kw7{min-height:inherit}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._1yt4j3ea{padding:var(--ds-space-400,2pc) 0 var(--ds-space-800,4pc) 0}";
const searchStyles = xcss({
  width: '16rem',
  maxWidth: '100%'
});
const SearchPageContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = FluidContainer,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4j3ea _1e0c1txw _2lx21bp4 _1tke1kw7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchPageContainer.displayName = 'SearchPageContainer';
}
const SearchPageEMCEEContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = SearchPageContainer,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt48v25", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchPageEMCEEContainer.displayName = 'SearchPageEMCEEContainer';
}
export const OutageErrorContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4fkly _1e0c1txw _2lx21bp4 _1tke1kw7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  OutageErrorContainer.displayName = 'OutageErrorContainer';
}
const EmbeddedFilterWrapper = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpu2gc _1e0c1txw _2lx21bp4", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  EmbeddedFilterWrapper.displayName = 'EmbeddedFilterWrapper';
}
const EmbeddedFilterWrapperStyle = null;
const SearchEmbeddedWrapper = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bsb1k7l _p12f1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SearchEmbeddedWrapper.displayName = 'SearchEmbeddedWrapper';
}
const fullWidthStyles = null;
const SearchResultPageWithAtlassianApps = props => {
  var _selectedOptions$host, _selectedOptions$host2;
  const {
    enableFlexibleBillingFilter
  } = useStatsig();
  const [showPageError, setShowPageError] = useState(false);
  const {
    query,
    categories,
    useCases
  } = useQueryParams();
  const searchQuery = getSearchQuery(query);

  // Separate refs for desktop and mobile to avoid conflicts in responsive layout
  const desktopSearchInputRef = useRef(null);
  const mobileSearchInputRef = useRef(null);
  const {
    handleErrorStateAnalytics
  } = useSearchPageAnalytics();
  const source = useSource();
  const appConfig = useApplicationConfig();
  const {
    filterDefinitions,
    additionalFilters
  } = useMemo(() => getOverridesByHostProduct({
    hostProductId: appConfig === null || appConfig === void 0 ? void 0 : appConfig.hostProductId,
    enableFlexibleBillingFilter: enableFlexibleBillingFilter()
  }), [appConfig === null || appConfig === void 0 ? void 0 : appConfig.hostProductId, enableFlexibleBillingFilter]);

  // Filter out price, billingModel, trustSignals for new UI
  const activeFilterDefinitions = useMemo(() => filterDefinitions.filter(filter => !['price', 'billingModel', 'trustSignals'].includes(filter.filterId)), [filterDefinitions]);
  const {
    filterOptions,
    selectedOptions,
    filterStatus,
    sortOptions,
    commitOptions,
    selectedMobileSortOption,
    showAllFilters,
    isFiltersFetchPending,
    setShowAllFilters,
    onClearFilter,
    onClearAllFilters,
    onSelectedOptionsChange,
    onApplyFilters,
    onSelectedSortOptionChange,
    onCloseMobileDialog,
    onCommitSortOptionSelect,
    handleClearFilters
  } = useSearchFilters(activeFilterDefinitions, source, true);

  // Force empty sortKey to prevent sorting in backend API
  const activeSortKey = '';
  const {
    gridProps,
    analyticsFilters
  } = useSearchResults(searchQuery, commitOptions, isFiltersFetchPending, activeSortKey, showPageError, additionalFilters);
  const isSearchQueryActive = !!searchQuery;
  const areFiltersActive = isOptionSelected(selectedOptions);
  const {
    enableMpacWebCoherence
  } = useStatsig();
  const isMpacWebCoherenceEnabled = enableMpacWebCoherence();
  useSearchPageTelemetry({
    gridProps,
    searchQuery,
    commitOptions,
    commitSortKey: activeSortKey
  });
  useEffect(() => {
    if ((filterStatus.categories === 'error' || filterStatus.useCases === 'error') && (categories || useCases)) {
      setShowPageError(true);
    }
  }, [categories, filterStatus, useCases]);
  useLayoutEffect(() => {
    Telemetry.timeToFirstMeaningfulPaint(performance.now());
  }, []);
  useEffect(() => {
    if (showPageError) {
      handleErrorStateAnalytics({
        actionSubjectId: 'SearchPageErrorRendered',
        errorType: ANALYTICS.GLOBAL
      });
    }
  }, [showPageError]);
  if (showPageError) {
    return /*#__PURE__*/_jsx(OutageErrorContainer, {
      children: /*#__PURE__*/_jsx(PartialOutageError, {
        level: "global"
      })
    });
  }
  const ContainerComponent = source === 'MPAC' ? SearchPageContainer : SearchPageEMCEEContainer;
  const productName = appConfig !== null && appConfig !== void 0 && appConfig.hostProductId ? CompatibleProductName[appConfig === null || appConfig === void 0 ? void 0 : appConfig.hostProductId] : undefined;
  const selectedHostingFilter = selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions$host = selectedOptions.hosting) === null || _selectedOptions$host === void 0 ? void 0 : (_selectedOptions$host2 = _selectedOptions$host[0]) === null || _selectedOptions$host2 === void 0 ? void 0 : _selectedOptions$host2.value;
  return /*#__PURE__*/_jsxs(ContainerComponent, {
    "data-testid": "".concat(source, "-fluid-container"),
    children: [/*#__PURE__*/_jsx(SearchHeading, {
      isSearchQueryActive: isSearchQueryActive,
      areFiltersActive: areFiltersActive,
      productName: productName,
      useAtlassianAppsExperimentNewUI: true
    }), /*#__PURE__*/_jsx(Show, {
      above: "lg",
      children: /*#__PURE__*/_jsxs(Flex, {
        direction: "row",
        gap: "space.100",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Box, {
          xcss: searchStyles,
          children: /*#__PURE__*/_jsx(SearchEmbedded, {
            searchInputRef: desktopSearchInputRef
          })
        }), /*#__PURE__*/_jsx(Filters, {
          filterOptions: filterOptions,
          filterDefinitions: activeFilterDefinitions,
          filterStatus: filterStatus,
          showAllFilters: showAllFilters,
          onShowAllFilters: () => setShowAllFilters(!showAllFilters),
          selectedOptions: selectedOptions,
          onSelectedOptionsChange: onSelectedOptionsChange,
          sortOptions: sortOptions,
          selectedSortOption: selectedMobileSortOption,
          onSelectedSortOptionChange: onSelectedSortOptionChange,
          onClearFilter: onClearFilter,
          onClearAllFilters: onClearAllFilters,
          onApplyFilters: onApplyFilters,
          onCloseMobileDialog: onCloseMobileDialog,
          useAtlassianAppsExperimentNewUI: true
        })]
      })
    }), /*#__PURE__*/_jsx(Show, {
      below: "lg",
      children: /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_10]
        }), /*#__PURE__*/_jsxs(EmbeddedFilterWrapper, {
          className: ax([isMpacWebCoherenceEnabled && "_zulputpp"]),
          children: [/*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_11]
            }), /*#__PURE__*/_jsx(SearchEmbeddedWrapper, {
              className: ax(["_1bsb1osq"]),
              children: /*#__PURE__*/_jsx(SearchEmbedded, {
                searchInputRef: mobileSearchInputRef
              })
            })]
          }), /*#__PURE__*/_jsx(Filters, {
            filterOptions: filterOptions,
            filterDefinitions: activeFilterDefinitions,
            filterStatus: filterStatus,
            showAllFilters: showAllFilters,
            onShowAllFilters: () => setShowAllFilters(!showAllFilters),
            selectedOptions: selectedOptions,
            onSelectedOptionsChange: onSelectedOptionsChange,
            sortOptions: sortOptions,
            selectedSortOption: selectedMobileSortOption,
            onSelectedSortOptionChange: onSelectedSortOptionChange,
            onClearFilter: onClearFilter,
            onClearAllFilters: onClearAllFilters,
            onApplyFilters: onApplyFilters,
            onCloseMobileDialog: onCloseMobileDialog,
            useAtlassianAppsExperimentNewUI: true
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(SearchResults, {
      searchInputRef: desktopSearchInputRef,
      gridProps: gridProps,
      isSearchQueryActive: isSearchQueryActive,
      onSortOptionSelect: onCommitSortOptionSelect,
      areFiltersActive: areFiltersActive,
      handleClearAllFilters: handleClearFilters,
      selectedSortKey: activeSortKey,
      analyticsFilters: analyticsFilters,
      isAppInstalled: props.isAppInstalled,
      selectedHostingFilter: selectedHostingFilter,
      useAtlassianAppsExperimentNewUI: true,
      cloudId: props.cloudId
    }), /*#__PURE__*/_jsx(BackToTopButton, {})]
  });
};
export default SearchResultPageWithAtlassianApps;